import React from "react";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";

export default function Sitemap() {
  return (
    <div className="container my-5">
      <SEO
        title="Site Map | 100Eyes Technologies LLP"
        description="Explore the sitemap of 100Eyes Technologies LLP for easy navigation across all our services and information pages."
        canonical="https://100eyestechnologies.com/sitemap"
      />

      <h1 className="mb-4 text-primary fw-bold">Site Map</h1>
      <p className="text-muted mb-4">
        Navigate easily across all sections of <strong>100Eyes Technologies</strong>.
      </p>

      <ul className="list-unstyled fs-5">
        <li><Link to="/" className="text-decoration-none text-dark">🏠 Home</Link></li>
        <li><Link to="/about-us" className="text-decoration-none text-dark">About Us</Link></li>
        <li><Link to="/service" className="text-decoration-none text-dark">Our Services</Link></li>
        <li><Link to="/blogs" className="text-decoration-none text-dark">Blogs</Link></li>
        <li><Link to="/contact-us" className="text-decoration-none text-dark">Contact Us</Link></li>
        <li><Link to="/call-us" className="text-decoration-none text-dark">Call Us</Link></li>
        <li><Link to="/privacy-policy" className="text-decoration-none text-dark">Privacy Policy</Link></li>
        <li><Link to="/terms-and-conditions" className="text-decoration-none text-dark">Terms & Conditions</Link></li>
        <li><Link to="/on-payroll" className="text-decoration-none text-dark">On Payroll</Link></li>
        <li><Link to="/mobile-app-development" className="text-decoration-none text-dark">Mobile App Development</Link></li>
        <li><Link to="/digital-marketing" className="text-decoration-none text-dark">Digital Marketing Services</Link></li>
        <li><Link to="/custom-software-development" className="text-decoration-none text-dark">Custom Software Development</Link></li>
        <li><Link to="/customer-relationship-management" className="text-decoration-none text-dark">Customer Relationship Management</Link></li>
        <li><Link to="/content-management-system" className="text-decoration-none text-dark">Content Management System</Link></li>
        <li><Link to="/business-automation" className="text-decoration-none text-dark">Business Automation</Link></li>
        <li><Link to="/ecommerce" className="text-decoration-none text-dark">E-Commerce Solution</Link></li>
        <li><Link to="/features" className="nav-item nav-link">Features</Link></li>
      </ul>
    </div>
  );
}
